import { render, staticRenderFns } from "./Laws.vue?vue&type=template&id=420fe5ba&"
import script from "./Laws.vue?vue&type=script&lang=js&"
export * from "./Laws.vue?vue&type=script&lang=js&"
import style0 from "./Laws.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports